import {
  BadgeDollarSign,
  BarChart3,
  BrainCircuit,
  ChartSpline,
  CircleDollarSign,
  FileCheck2,
  Languages,
  LayoutDashboard,
  MessageSquareText,
  Route as RouteIcon,
  Settings,
  ShieldCheck,
  Sparkles,
  SquareFunction,
  Users,
  type LucideIcon
} from 'lucide-react'

export interface NavigationItem {
  to: string
  icon: LucideIcon
  labelKey: string
}

export interface NavigationDomain {
  key: 'overview' | 'operations' | 'finance' | 'ai' | 'system'
  to: string
  icon: LucideIcon
  labelKey: string
  items: NavigationItem[]
}

const dashboardNavigationItem: NavigationItem = {
  to: '/overview',
  icon: LayoutDashboard,
  labelKey: 'nav.overview'
}

export const navigationDomains: NavigationDomain[] = [
  {
    key: 'overview',
    to: dashboardNavigationItem.to,
    icon: LayoutDashboard,
    labelKey: 'nav.overview',
    items: [dashboardNavigationItem]
  },
  {
    key: 'operations',
    to: '/users',
    icon: BarChart3,
    labelKey: 'sidebar.groups.operations',
    items: [
      {
        to: '/users',
        icon: Users,
        labelKey: 'nav.users'
      },
      {
        to: '/ai-usage',
        icon: ChartSpline,
        labelKey: 'nav.aiUsage'
      }
    ]
  },
  {
    key: 'finance',
    to: '/finance',
    icon: CircleDollarSign,
    labelKey: 'sidebar.groups.finance',
    items: [
      {
        to: '/finance',
        icon: CircleDollarSign,
        labelKey: 'nav.finance'
      },
      {
        to: '/reconciliation',
        icon: FileCheck2,
        labelKey: 'nav.reconciliation'
      },
      {
        to: '/models',
        icon: BadgeDollarSign,
        labelKey: 'nav.models'
      }
    ]
  },
  {
    key: 'ai',
    to: '/ai-functions',
    icon: Sparkles,
    labelKey: 'sidebar.groups.ai',
    items: [
      {
        to: '/ai-functions',
        icon: SquareFunction,
        labelKey: 'nav.aiFunctions'
      },
      {
        to: '/ai-models',
        icon: BrainCircuit,
        labelKey: 'nav.aiModels'
      },
      {
        to: '/dispatch-chains',
        icon: RouteIcon,
        labelKey: 'nav.dispatchChains'
      },
      {
        to: '/prompts',
        icon: MessageSquareText,
        labelKey: 'nav.prompts'
      }
    ]
  },
  {
    key: 'system',
    to: '/settings',
    icon: Settings,
    labelKey: 'sidebar.groups.system',
    items: [
      {
        to: '/settings',
        icon: Settings,
        labelKey: 'nav.settings'
      },
      {
        to: '/locales',
        icon: Languages,
        labelKey: 'nav.locales'
      },
      {
        to: '/admins',
        icon: ShieldCheck,
        labelKey: 'nav.admins'
      }
    ]
  }
]

const navigationItems = navigationDomains.flatMap((domain) => domain.items)

export function navigationItemForPath(pathname: string): NavigationItem | undefined {
  return navigationItems.find((item) => pathname === item.to)
}

export function navigationDomainForPath(pathname: string): NavigationDomain | undefined {
  return navigationDomains.find((domain) => domain.items.some((item) => item.to === pathname))
}
